<template>
  <div>
    <!-- <div class="choose-box--feature">
      <div class="choose-box--feature__small">FEATURES FOR</div>
      <div class="choose-box--feature__large">Advocates</div>
      <div class="choose-box--feature__medium">
        Examples of advocate include pharmaceutical representatives, biomedical
        scientists, researchers.<br />
        Whether you represent an organization or are passionate about advocating
        a cause, MyCircles provides a platform to share and learn more about
        various chronic conditions and current medical advances for chronic
        conditions.
      </div>
    </div> -->
    <div class="full dark-bg">
      <div class="create-support  dovemed-wrapper reverse">
        <div class="create-support__image">
          <img
            alt="img"
            src="../../../../assets/images/adv1.jpg"
            class="img-src"
          />
        </div>
        <div class="create-support__description">
          <div class="create-support__description__small">
            CONNECT AND RAISE
          </div>
          <div class="create-support__description__large">Awareness</div>
          <div class="create-support__description__medium">
            Connect with others to raise awareness throughout various
            communities supporting individuals with chronic conditions.
          </div>
        </div>
      </div>
    </div>
    <div>
      <div class="create-support  ">
        <div class="create-support__image">
          <img
            alt="img"
            src="../../../../assets/images/adv2.jpg"
            class="img-src"
          />
        </div>
        <div class="create-support__description">
          <div class="create-support__description__small">SEARCH</div>
          <div class="create-support__description__large">
            Current Medical Research
          </div>
          <div class="create-support__description__medium">
            Share current medical research and expertise as it relates to
            chronic conditions for MyCircles Communities.
          </div>
        </div>
      </div>
    </div>
    <div class="full dark-bg">
      <div class="create-support dovemed-wrapper reverse">
        <div class="create-support__image">
          <img
            alt="img"
            src="../../../../assets/images/adv3.jpg"
            class="img-src"
          />
        </div>
        <div class="create-support__description">
          <div class="create-support__description__small">
            LEARN
          </div>
          <div class="create-support__description__large">
            First-Hand
          </div>
          <div class="create-support__description__medium">
            Learn about Chronic conditions from first-hand experiences or
            provide recommendations to better manage living with chronic
            conditions.
          </div>
        </div>
      </div>
    </div>
    <div class="create-support  ">
      <div class="create-support__image">
        <img
          alt="img"
          src="../../../../assets/images/adv4.jpg"
          class="img-src"
        />
      </div>
      <div class="create-support__description">
        <div class="create-support__description__small">GAIN</div>
        <div class="create-support__description__large">
          Insights
        </div>
        <div class="create-support__description__medium">
          Gain insights on patient preferences for treatments and various
          products/services as it relates to each chronic condition.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AdvocateStatic"
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/App/circle/AllCircleStaticPages/AdvocateStatic.vue